import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as Mui from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { themes } from "services/constants";
import { setCurrentScreen } from "services/Redux/userManagament";
import { setGlobalSearchValue } from "services/Redux/userToken";
import {
  setDepartmentId,
  setDepartmentLeadId,
  setDepartmentName,
  setShiftCategoryId,
} from "services/Redux/userManagament";
import { setReloadHRMSApi } from "services/Redux/leaveManagement";
import { tooltipStyleProps } from "services/constants/Styles";

export const CardView = ({
  departmentList,
  setLeavePage,
  Page,
  masterDataForSearch,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowsPerPage, setLeaveRowsPerPage] = useState(25);
  const handleChangeLeavePage = (event, newPage) => {
    setLeavePage(newPage);
  };

  const handleChangeLeaveRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      {departmentList?.length > 0 ? (
        <>
          <Mui.Grid
            container
            spacing={2}
            sx={{
              justifyContent: "center",
              flexWrap: "wrap",
              px: 1,
              alignItems: "stretch",
            }}
          >
            {departmentList
              .slice(Page * rowsPerPage, Page * rowsPerPage + rowsPerPage)
              .map((department, index) => (
                <Mui.Grid
                  item
                  key={department.id}
                  spacing={5}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "stretch",
                  }}
                >
                  <Mui.Card
                    variant="outlined"
                    sx={{
                      marginTop: 4,
                      borderRadius: 3,
                      width: "100%",
                      maxWidth: 350,
                      minWidth: 250,
                      boxShadow: 3,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Mui.CardContent>
                      <Mui.Grid
                        container
                        sx={{
                          paddingBottom: 1,
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <Mui.Grid item xs={10} sx={{ minWidth: 0 }}>
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={department.department_name}
                          >
                            <Mui.Typography
                              sx={{
                                color: themes.headLine,
                                fontSize: { xs: 16, sm: 18, md: 20, lg: 22 },
                                fontWeight: 600,
                                textAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "90%",
                              }}
                            >
                              {department.department_name}
                            </Mui.Typography>
                          </Mui.Tooltip>
                        </Mui.Grid>
                        <Mui.Grid
                          item
                          xs={2}
                          sx={{ textAlign: "left", ml: -1.5 }}
                        >
                          {department.department_name === "All" ? null : (
                            <Mui.IconButton
                              size="small"
                              onClick={(e) => {
                                dispatch(
                                  setDepartmentId(department.department_id)
                                );
                                dispatch(
                                  setDepartmentLeadId(
                                    department.department_lead_id
                                  )
                                );
                                dispatch(
                                  setDepartmentName(department.department_name)
                                );
                                dispatch(
                                  setShiftCategoryId(
                                    department.shift_category_id
                                  )
                                );
                                handleMenuOpen(e, index);
                              }}
                              disabled={department.department_id ? false : true}
                            >
                              <MoreVertIcon />
                            </Mui.IconButton>
                          )}
                          <Mui.Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            elevation={1}
                            transformOrigin={{
                              horizontal: "right",
                              vertical: "top",
                            }}
                            anchorOrigin={{
                              horizontal: "right",
                              vertical: "bottom",
                            }}
                          >
                            <Mui.Stack>
                              <Mui.Stack>
                                <Mui.MenuItem
                                  onClick={() => {
                                    dispatch(setGlobalSearchValue(""));
                                    history.push(
                                      "/admin/attendance/view/members"
                                    );
                                  }}
                                >
                                  View Members
                                </Mui.MenuItem>
                              </Mui.Stack>
                            </Mui.Stack>
                            <Mui.Stack>
                              <Mui.MenuItem
                                onClick={() => {
                                  dispatch(setCurrentScreen("Shift"));
                                  localStorage.setItem(
                                    "currentSubMenu",
                                    "Shift"
                                  );
                                  dispatch(setGlobalSearchValue(""));
                                  history.push("/admin/teamzone/plan-shift");
                                }}
                              >
                                Plan Shift
                              </Mui.MenuItem>
                            </Mui.Stack>
                          </Mui.Menu>
                        </Mui.Grid>
                      </Mui.Grid>

                      {[
                        {
                          label: "Total no of staffs",
                          value: department.total_staff_count,
                        },
                        {
                          label: "No of staffs planned",
                          value: department.staff_planned_count,
                        },
                        {
                          label: "No of staffs present",
                          value: department.staff_present_count,
                        },
                        {
                          label: "No of staffs in overtime",
                          value: department.staff_overtime_count,
                        },
                        {
                          label: "No of staffs missing",
                          value: department.staff_missing_count || "0",
                        },
                        {
                          label: "No of staffs absent",
                          value: department.staff_absent_count,
                        },
                        {
                          label: "No of staffs late / early",
                          value: department.staff_late_early
                            ? department.staff_late_early
                            : 0,
                        },
                      ].map((stat, idx) => (
                        <Mui.Grid
                          container
                          key={idx}
                          sx={{
                            paddingBottom: 1,
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            dispatch(setGlobalSearchValue(""));
                            dispatch(
                              setDepartmentId(
                                department.department_id
                                  ? department.department_id
                                  : 99999
                              )
                            );
                            dispatch(
                              setDepartmentLeadId(
                                department?.department_lead_id
                                  ? department?.department_lead_id
                                  : 99999
                              )
                            );
                            dispatch(
                              setDepartmentName(department?.department_name)
                            );
                            dispatch(
                              setShiftCategoryId(
                                department?.shift_category_id
                                  ? department?.shift_category_id
                                  : 99999
                              )
                            );
                            localStorage.setItem(
                              "approveLeaveDepartmentId",
                              department?.department_id
                                ? department?.department_id
                                : 99999
                            );
                            localStorage.setItem(
                              "approveLeaveDepartmentName",
                              department?.department_name
                            );
                            dispatch(setReloadHRMSApi(false));
                            history.push("/admin/teamzone/attendances/status");
                          }}
                        >
                          <Mui.Grid item xs={10}>
                            <Mui.Typography
                              sx={{
                                fontSize: 14,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {stat.label}
                            </Mui.Typography>
                          </Mui.Grid>
                          <Mui.Grid item xs={2}>
                            <Mui.Typography
                              sx={{ fontWeight: "bold", fontSize: 16 }}
                            >
                              {stat.value}
                            </Mui.Typography>
                          </Mui.Grid>
                        </Mui.Grid>
                      ))}
                    </Mui.CardContent>
                  </Mui.Card>
                </Mui.Grid>
              ))}
          </Mui.Grid>
        </>
      ) : (
        <Mui.Container maxWidth="xl" sx={{ marginTop: 2 }}>
          <Mui.Alert severity="info">
            {masterDataForSearch?.length !== 0
              ? "No matching data found for your search."
              : "No data available."}
          </Mui.Alert>
        </Mui.Container>
      )}
      {departmentList?.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={departmentList?.length}
          rowsPerPage={rowsPerPage}
          page={Page}
          onPageChange={handleChangeLeavePage}
          onRowsPerPageChange={handleChangeLeaveRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};
